<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form (ngSubmit)="confirmBlock(customer)" class="dialog-form" name="deleteForm">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>{{ 'entity.block.title' | translate }}</h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>
    <div *ngIf="customer" class="siklu-mat-dialog-body" matDialogContent>
        <winde-alert-error></winde-alert-error>
        <p
                [translateParams]="{
                name: customer.name | gtthTextEscape,
                action: customer.blocked ? 'unblock' : ('block' | gtthTextEscape)
            }"
                [translate]="'customer.block.question'"
        >
            Are you sure you want to block this Company?
        </p>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button matDialogClose windeTransparent>
            <sui-svg-icon icon="cross"/>
            {{ 'entity.action.cancel' | translate }}
        </button>
        <button *ngIf="customer" type="submit" windeRed>
            <sui-svg-icon icon="ban"/>
            {{ 'entity.action.' + (customer.blocked ? 'unblock' : 'block') | translate }}
        </button>
    </div>
</form>
